import { render, staticRenderFns } from "./ImageList.vue?vue&type=template&id=064ab03c"
import script from "./ImageList.vue?vue&type=script&lang=js"
export * from "./ImageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports